<div class="flex-container align-center tertiary-container">
    <div class="msg flex-container">
        {{'general.update_available'|translate}}
    </div>
    <div class="btn flex-container">
        <button matButton mat-dialog-close class="">{{'general.install'|translate}} </button>
    </div>
</div>